import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { languages } from "@/lib/translations";
import { Globe, Check } from "lucide-react";

export default function LanguageSwitcher() {
    const { i18n } = useTranslation();
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const close = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", close);
        return () => document.removeEventListener("mousedown", close);
    }, []);

    const current = languages.find((l) => l.code === i18n.language?.slice(0, 2)) || languages[0];

    return (
        <div className="relative" ref={ref}>
            <button
                onClick={() => setOpen(!open)}
                className="flex items-center gap-1.5 p-2 rounded-full hover:bg-[#F5F0E6] text-sm"
                style={{ color: "#1E1B4B" }}
                data-testid="nav-lang-button"
                title="Language"
            >
                <Globe size={16} />
                <span className="hidden sm:inline text-xs font-medium">{current.code.toUpperCase()}</span>
            </button>
            {open && (
                <div
                    className="absolute right-0 mt-2 w-44 p-card p-2 z-50"
                    data-testid="nav-lang-menu"
                >
                    {languages.map((l) => (
                        <button
                            key={l.code}
                            onClick={() => {
                                i18n.changeLanguage(l.code);
                                setOpen(false);
                            }}
                            className="w-full text-left px-3 py-2 rounded-xl text-sm flex items-center justify-between hover:bg-[#F5F0E6]"
                            style={{ color: "#1E1B4B" }}
                            data-testid={`nav-lang-${l.code}`}
                        >
                            <span className="font-medium">{l.native}</span>
                            {current.code === l.code && <Check size={14} style={{ color: "#7F1D1D" }} />}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
